/**
 * SearchSpring API request handler
 * Manages SearchSpring API requests with session tracking and request header generation
 */

import { session } from '@/components/helpers/session'
import { SearchspringParams } from 'libs/searchspring/classes/searchspring-params'

export class SearchspringFetcher {
  params

  constructor(category) {
    this.params = new SearchspringParams(category)
  }

  generateHeaders() {
    const pageLoadID = session.pageLoadId.get()
    const sessionID = session.sessionId.get()
    const userID = session.userId.get()

    return new Headers({
      Accept: 'application/json',
      'searchspring-user-id': userID,
      'searchspring-session-id': sessionID,
      'searchspring-page-load-id': pageLoadID
    })
  }

  generateRequestInit() {
    return {
      method: 'GET',
      headers: this.generateHeaders()
    }
  }

  generateOrigin() {
    return `https://${this.params.siteID}.a.searchspring.io`
  }

  updateParams() {
    this.params.setSiteIDParam()
  }

  generateURL(endpoint) {
    const origin = this.generateOrigin()
    const params = this.params.toString()
    return new URL(`${origin}${endpoint}?${params}`)
  }

  async fetch(controller) {
    const requestInit = this.generateRequestInit()
    if (controller) requestInit.signal = controller.signal
    const url = this.generateURL()
    const response = await fetch(url, requestInit)
    return await response.json()
  }
}
